import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PatientEditComponent } from './patient-edit.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PipesModule } from '../pipes/pipes.module';
import { AddressValidatorModule } from '../address-validator/address-validator.module';
import { PatientEditConsentComponent } from './patient-edit-consent/patient-edit-consent.component';
import { MemberConsentListService } from 'src/app/core/service/grid-data/grid-data-member-consent.service';
import { DocumentModule } from 'src/app/document/document.module';
import { CollapsibleModule } from '../collapsible/collapsible.module';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@NgModule({
    imports: [
        CommonModule,
        DialogsModule,
        PopupModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        LabelModule,
        LayoutModule,
        ButtonModule,
        ButtonsModule,
        DropDownsModule,
        DateInputsModule,
        GridModule,
        PipesModule,
        AddressValidatorModule,
        DocumentModule,
        CollapsibleModule,
        TooltipModule
    ],
    declarations: [
        PatientEditComponent,
        PatientEditConsentComponent
    ],
    exports: [
        PatientEditComponent
    ],
    providers: [MemberConsentListService]
})
export class PatientEditModule { }
